import { Moment } from "moment-timezone";

export function buildTimePickerChangeDate(time: Moment, value: Date) {
    const newDate = new Date(value);
    newDate.setHours(time.hours());
    newDate.setMinutes(time.minutes());
    newDate.setSeconds(time.seconds());
    newDate.setMilliseconds(time.milliseconds());
    return newDate;
}
